<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <x-y-chart
        v-for="data in dataList"
        :key="data.id"
        :data-config="data"
        :unit-prop="unitProp"
        :chart-type="chartType"
        :stack-type="stackType"
        :download-name="downloadName"
        chart-min-height="400px"
        chart-height="auto"
        style="flex:1 0 100%;"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import XYChart from '../../../../components/DataChart/XYChart'
import YaoBaseSiteFactorData from '../../../YaoBaseSiteFactorData'

export default {
  name: 'StatisticalAnalysisVOCsNOxO3',
  routeInfo: {
    label: 'VOCs NOx O3',
    icon: 'fa fa-users'
  },
  extends: YaoBaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, XYChart},
  data: () => ({
    query: {
      isFuse: false,
      isMultipleIntegral: true,
      unit: 'μg/m3'
    },
    chartType: 'line',
    stackType: 0
  }),
  computed: {
    siteDeviceCategory: () => process.env.ALL_VOCS_DEVICE_CATEGORY | process.env.NO_DEVICE_CATEGORY | process.env.O3_DEVICE_CATEGORY,
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, true, siteDeviceFactors => [{
        id: 'VOCs',
        factorId: 'VOCs',
        name: 'VOCs',
        displayUnit: 'μg/m3'
      }]),
      new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => /^100(2|3)$/.test(siteDeviceFactor.factorId))),
      new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '1006'))
    ],
    downloadName: () => 'VOCs-NOx-O3'
  },
  methods: {
    // onAuditCompletedChanged () {
    //   let {query} = this
    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }
    //   query.isMultipleIntegral = false

    //   this.afterSetSiteIds()
    // },
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    getData () {
      this.changeLoadStatus(true)
      const {currentQuery} = this
      Promise.all([
        this.$api.Data.getVOCsAndOther(currentQuery),
        this.$api.NoData.getNoDataListBySite(currentQuery)
      ]).then(this.setAllDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/08VOCs-NOx-O3/index.vue